import { httpClient } from '../transports/http.js'  

export async function getEquipmentData(params) {
  return (await httpClient.post('api/' + (params.isAuth
    ? 'EAM.QR.GETALLEQUIPINFO.AUTH'
    : '_EAM.QR.GETALLEQUIPMENTINFO'), params)).data
}

export async function toggleEquipmentFavorite(params) {
  return (await httpClient.post('api/EAM.EQUIP.TOGGLEFAV', params)).data
} 

export async function getWorkRequestsTable(params) {
  return (await httpClient.post('api/EAM.WORKREQUESTS.GET', params)).data
}

export async function getEquipmentInfo(params) {
  const data = (await httpClient.post('api/' + (params.isAuth
    ? '_EAM.QR.GETEQUIPMENTINFO.AUTH'
    : 'EAM.QR.GETEQUIPMENTINFO'), params)).data
  return data
}
